import Button from "@components/Button"
import Layout from "@components/Layout"
import PasswordInput from "@components/PasswordInput"
import { setPasswordInSessionStorage } from "@helpers/sessionStorage"
import { validatePassword } from "@helpers/validations"
import { IsUserSignedInLoaderData } from "@loaders/isUserSignedInLoader"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { Navigate, useLoaderData, useNavigate } from "react-router-dom"

export default function PasswordPage() {
  const [password, setPassword] = useState("")
  const [passwordValid, setPasswordValid] = useState(true)

  const navigate = useNavigate()
  const { isUserSignedIn } = useLoaderData() as IsUserSignedInLoaderData
  const { t } = useTranslation()

  if (isUserSignedIn) {
    return <Navigate to="/sign-up/building-plan" />
  }

  const isPasswordValid = validatePassword(password)

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (isPasswordValid) {
      setPasswordInSessionStorage(password)
      navigate("/sign-up/email")
    } else {
      setPasswordValid(false)
    }
  }

  return (
    <Layout>
      <div className="shrink-0 space-y-6 text-center">
        <h1 className="custom-heading">{t("pages.signUp.password.heading")}</h1>

        <p
          className={
            passwordValid ? "custom-subheading" : "custom-subheading-error"
          }
        >
          {t("pages.signUp.password.subheading")}
        </p>
      </div>

      <form
        className="flex grow flex-col justify-between"
        onSubmit={handleSubmit}
      >
        <div className="flex grow flex-col justify-center">
          <PasswordInput
            autoFocus
            invalid={!passwordValid}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        <div className="shrink-0 text-center">
          <Button
            disabled={password.length < 1}
            iconOnly
            type="submit"
            title={t("shared.continue")}
          />
        </div>
      </form>
    </Layout>
  )
}
